export const asyncHandler = async ({ func, errorMessage }) => {
  try {
    return await func();
  } catch (error) {
    // console.error(`${errorMessage}: `, error);
    throw new Error(errorMessage);
  }
};
